import { render, staticRenderFns } from "./Textinput.vue?vue&type=template&id=4d68c5d9&"
import script from "./Textinput.vue?vue&type=script&lang=js&"
export * from "./Textinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports